// import aspnetroles from '$modules/roles/routes'
// import userRoles from '$modules/userRoles/routes'

export default [
  {
    path: 'user',
    meta: {
      title: 'Users',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'account_circle'
    },
    component: () => import('./pages/index'),
    redirect: 'user/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'aspnetuser',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'aspnetuser',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'aspnetuser',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
